/**
 * Synchronously stops all MediaStreamTrack objects in the document.
 *
 * Enumerates all <video> and <audio> elements and calls track.stop() on any
 * whose srcObject is a MediaStream (WebRTC / getUserMedia). This bypasses
 * the Chime SDK's async pipeline, ensuring the camera/mic hardware is
 * released immediately — critical in useEffect cleanup where async
 * operations are fire-and-forget.
 *
 * Only targets MediaStream-backed elements. Regular <video src="...">
 * playback (e.g. VideoPlayerBase) is unaffected.
 *
 * track.stop() is idempotent — calling it on an already-stopped track is
 * a no-op.
 */
export function stopAllMediaTracks(): void {
  try {
    document.querySelectorAll("video, audio").forEach((el) => {
      const mediaEl = el as HTMLMediaElement;
      const src = mediaEl.srcObject;
      if (src instanceof MediaStream) {
        src.getTracks().forEach((t) => t.stop());
        mediaEl.srcObject = null;
      }
    });
  } catch {
    // Best effort — cleanup must not throw
  }
}
